export default __webpack_public_path__ + "dd3e6d8833aca7eda6cbd62f0faf609a.png";